import { render, staticRenderFns } from "./TicketMessage.vue?vue&type=template&id=35fd1de2&scoped=true&"
import script from "./TicketMessage.vue?vue&type=script&lang=js&"
export * from "./TicketMessage.vue?vue&type=script&lang=js&"
import style0 from "./TicketMessage.vue?vue&type=style&index=0&id=35fd1de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd1de2",
  null
  
)

export default component.exports